<template>
  <div style="width:100%;float:left;">
    <CCard>
      <CCardHeader>File(s) Area</CCardHeader>
      <CCardBody>
        <CCol col="12" class="float-left mb-2 p-0 text-center">
          <vue-dropzone ref="myVueDropzone" @vdropzone-file-added="addFile" name="files" id="dropzone" :options="dropzoneOptions"></vue-dropzone>
          <CButton size="sm" color="success" v-if="imageUploads.length && !fileLoading" class="mt-2 ml-auto mr-auto" @click="uploadFiles()">Submit Upload</CButton>
          <small-loader v-else-if="fileLoading"></small-loader>
        </CCol>
        <spacer />
        <!-- <CCol col="12" class="float-left mb-2">
          <CButton size="sm" style="width:100%;" color="primary" v-if="!downloadLoading" @click="">Upload File(s) To {{pdf.as400_log_number}}
            <CIcon name="cil-cloud-upload" />
          </CButton>
          <small-loader v-else></small-loader>
        </CCol> -->
        <CCol col="12" class="float-left p-0" style="background-color:#000;" v-if="groupImages">
          <h5 style="width:100%;float:left;text-align: center;font-size:12px;color:#e0e0e0;">Click on image to view fullscreen</h5>
          <div style="width:100%;float:left;">
            <CCarousel
              arrows
              indicators
              animate
              height="250px"
              v-if="groupImages"
              @setItem="slide"
              ref="carousel"
            >
              <!-- <CCarouselItem
                captionHeader="First Slide"
                image="https://picsum.photos/1024/480/?image=52"
                captionText="Nulla vitae elit libero, a pharetra augue mollis interdum."
              />
              <CCarouselItem
                captionHeader="Blank page"
                :image="{ placeholderColor: 'grey' }"
                captionText="Nulla vitae elit libero, a pharetra augue mollis interdum."
              /> -->
              <CCarouselItem
                v-for="(image, index) in groupImages"
                style="height:200px;"
                :key="index"
                :index="index"
              >
                <div style="width:100%;height:100%;" v-if="!loadingItem">
                  <image-wrapper :auto_load="true" v-if="checkShow(index)" :imageArray="groupImages" :imageIndex="index" imgStyle="max-width:100%;max-height:200px;" :src="image.file_url" :img="image" />
                </div>
              </CCarouselItem>
            </CCarousel>
          </div>
        </CCol>
        <CCol col="12" class="float-left p-0">
          <CButton size="sm" style="width:100%;" color="light" v-if="!downloadLoading && groupImages" @click="downloadFiles()">Download Order File(s)
            <CIcon name="cil-cloud-download" />
          </CButton>
          <small-loader v-else-if="downloadLoading"></small-loader>
        </CCol>
      </CCardBody>
    </CCard>
  </div>
</template>
<script>
var methods = {}

methods.checkShow = function (index) {
  console.log('checkshow')
  console.log(this.$refs)
  var r = false
  if (this.$refs.carousel) {
    console.log('oooo')
    console.log(this.$refs)
    console.log(index)
    if (this.$refs.carousel.active === index) {
      r = true
    }
  }
  console.log(r)
  return r
}

methods.downloadFiles = function () {
  this.downloadLoading = true
  console.log(this.pdf)
  const postData = {
    data: this.pdf
  }
  axios.get(this.$apiAdress + '/api/orders/downloadFiles/' + this.pdf.order_group_id + '?token=' + localStorage.getItem('api_token'), {responseType: "arraybuffer"}).then(response => {
    console.log(response)
    this.doDownload(response)
  })
}

methods.slide = function (e) {
  console.log('slide')
  console.log(e)
}

methods.removeZip = function () {
  axios.get(this.$apiAdress + '/api/orders/removeZip/' + this.pdf.order_group_id + '?token=' + localStorage.getItem('api_token')).then(response => {
    console.log(response)
    // this.doDownload(response)
  })
}

methods.doDownload = function (response) {
  var newBlob = new Blob([response.data], {type: 'application/zip'})

  // IE doesn't allow using a blob object directly as link href
  // instead it is necessary to use msSaveOrOpenBlob
  if (window.navigator && window.navigator.msSaveOrOpenBlob) {
    window.navigator.msSaveOrOpenBlob(newBlob)
    return
  }

  // For other browsers:
  // Create a link pointing to the ObjectURL containing the blob.
  const data = window.URL.createObjectURL(newBlob)
  var link = document.createElement('a')
  link.href = data
  link.download = this.pdf.as400_log_number + '.zip'
  link.click()
  this.downloadLoading = false
  this.removeZip()
  setTimeout(function () {
    // For Firefox it is necessary to delay revoking the ObjectURL
    window.URL.revokeObjectURL(data)
  }, 100)
}

methods.carClicked = function (val) {
  console.log('car clicked')
  this.$store.commit('setImageViewer', val)
}

methods.configureImages = function () {
  console.log('images')
  console.log(this.pdf)
  var arr = []
  var obj = {}
  this.pdf.order_items.forEach(function (item) {
    item.order_item_locations.forEach(function (location ) {
      if (location.file_url) {
        var n = location.file_url
        if (!obj[n]) {
          arr.push(location.decoration)
          obj[n] = n
        }
      }
    })
  })
  if (this.pdf.uploaded_files) {
    this.pdf.uploaded_files.forEach(function (file) {
      arr.push(file)
    })
  }
  if (arr.length) {
    this.groupImages = arr
  } else {
    this.groupImages = null
  }
  var that = this
  setTimeout(function () {
    that.loadingItem = false
  }, 1000)
}

methods.addFile = function (file) {
  console.log('file added')
  console.log(file)
  var fileReader = new FileReader();
  var f;
  var that = this
  fileReader.onload = (fileLoadedEvent) => {
          f = fileLoadedEvent.target.result;
          // base64 is the dataURL
          file.dataURL = f
          that.imageUploads.push(file)
          console.log(that.imageUploads)
  };
  fileReader.readAsDataURL(file);
  // this.imageUploads.push(file)
}

methods.addFiles = function (files) {
  console.log('filesssss added')
  console.log(files)
  // this.imageUploads.push(file)
}

methods.uploadFiles = function () {
  // process.env.VUE_APP_SERVER_HOST + '/api/media/uploadFileToOrderGroup?token=' + localStorage.getItem("api_token")
  this.fileLoading = true
  const postData = {
    files: this.imageUploads,
    order_group_id: this.pdf.order_group_id
  }
  console.log(postData)
  axios.post(this.$apiAdress + '/api/media/uploadFileToOrderGroup?token=' + localStorage.getItem('api_token'), postData).then(response => {
    this.fileLoading = false
    this.$refs.myVueDropzone.removeAllFiles()
    console.log(response)
  })
}

export default {
  // ===Component name
  name: "FilesViewer",
  // ===Props passed to component
  props: ['pdf'],
  // ===Components used by this component
  components: {
    // vueDropzone: vue2Dropzone
  },
  // ====component Data properties
  data(){
      return{
        groupImages: null,
        downloadLoading: false,
        fileLoading: false,
        imageUploads: [],
        loadingItem: true,
        dropzoneOptions: {
            url: 'test',
            autoProcessQueue: false,
            thumbnailWidth: 150,
            maxFilesize: 10.0,
            headers: { "Upload File(s)": "" }
        }
      }
  },
  // ===Code to be executed when Component is mounted
  mounted() {
    this.configureImages()
  },
  watch: {
    '$refs': function (newVal, oldVal) {
      console.log('refs changed')

    }
  },
  // ===Computed properties for the component
  computed: {},
  // ===Component methods
  methods: methods
}
</script>
<!-- styles -->
<!-- adding scoped attribute will apply the css to this component only -->
<style scoped></style>
